<template>
    <div  class="z-add-person" v-form="'back-add-person'">
        <div class="double-wrap">
            <div class="left">
                <div class="back-item">
                    <div class="back-title">姓名</div>
                    <div class="back-wrap">
                        <el-input class="top-choose z-mid" v-model="sub.name" v-tar="sub.name" rule="noVal" placeholder="请输入职员姓名"></el-input>
                    </div>
                </div>

                <div class="back-item">
                    <div class="back-title">账号</div>
                    <div class="back-wrap text">
                        {{ sub.account }}
                        <!-- <el-input class="top-choose z-mid" v-model="sub.account" v-tar="sub.account" rule="noVal" placeholder="请输入职员账号"></el-input> -->
                    </div>
                </div>

                <div class="back-item">
                    <div class="back-title">工号</div>
                    <div class="back-wrap">
                        <el-input class="top-choose z-mid" v-model="sub.job_num" v-tar="sub.job_num" rule="noVal" placeholder="请输入职员工号"></el-input>
                    </div>
                </div>

            </div>

            <div class="right">
                <div class="back-item">
                    <div class="back-title">入职时间</div>
                    <div class="back-wrap">
                        <el-date-picker class="top-choose z-mid" v-model="sub.work_date" v-tar="sub.work_date" rule="noVal" type="date" placeholder="请选择入职日期" :picker-options="picker_special">
					    </el-date-picker>
                    </div>
                </div>

                <div class="back-item">
                    <div class="back-title">出生日期</div>
                    <div class="back-wrap">
                        <el-date-picker class="top-choose z-mid" v-model="sub.birth_date" v-tar="sub.birth_date" rule="noVal" type="date" placeholder="请选择出生日期" :picker-options="picker_special">
					    </el-date-picker>
                    </div>
                </div>

                <div class="back-item">
                    <div class="back-title">手机号码</div>
                    <div class="back-wrap">
                        <el-input class="top-choose z-mid" v-model="sub.phone_num" v-tar="sub.phone_num" rule="noVal phone" placeholder="请输入手机号码"></el-input>
                    </div>
                </div>
            </div>

        </div>

        <!-- 职位属性 -->
        <div class="title">职位属性</div>
        <div class="double-wrap">
            
            <div class="left">
                <div class="back-item">
                    <div class="back-title">岗位</div>
                    <div class="back-wrap">
                        <el-select class="top-choose z-mid" rule="noVal" v-model="sub.position_id" v-tar="sub.position_id" clearable placeholder="请选择岗位">
                            <z-limitOption v-for="item in post_list" :key="item.id" :value="item.id" :label="item.positionName">
                            </z-limitOption>
                        </el-select>
                    </div>
                </div>

                <div class="back-item">
                    <div class="back-title">职级</div>
                    <div class="back-wrap">
                        <el-input class="top-choose z-mid" rule="noVal" v-model="sub.rank" v-tar="sub.rank" placeholder="请输入职级">
                            <template slot="append">级</template>
                        </el-input>
                    </div>
                </div>

                <div class="back-item">
                    <div class="back-title">所属BU</div>
                    <div class="back-wrap" :class="{text:id}">
                        <div v-if="id">{{ bu_name }}</div>
                        <el-select v-else class="top-choose z-mid" rule="noVal" v-model="sub.bu_id" v-tar="sub.bu_id"  clearable placeholder="请选择所属BU">
                            <el-option v-for="item in bu_list" :key="item.id" :value="item.id" :label="item.buName">
                            </el-option>
                        </el-select>
                    </div>
                </div>

            </div>

            <div class="right">
                <div class="back-item">
                    <div class="back-title">角色设置</div>
                    <div class="back-wrap">
                        <div class="check-head">
                            <el-checkbox v-model="check_all"  @change="chooseAll">{{ "全选" }}</el-checkbox>
                        </div>
                        <el-checkbox-group class="role-wrap" v-model="sub.role_ids" v-tar="role_str" @change="roleCheck">
                            <el-checkbox class="role-item" v-for="item in role_list" :key="item.id" :label="item.id">{{ item.displayName }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </div>

        </div>

        <div class="btns">
            <div class="back-btn blue" :class="{disabled:!now_form.changeFlag}" @click="save">{{ text }}</div>
            <div class="back-btn" :class="{disabled:!now_form.changeFlag}" @click="cancel">取消</div>
        </div>

    </div>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        props:["id",'index'],
        data(){
            return {
                now_form:{},
                sub:{
                    name:"",       //姓名
                    account:"",    //账号         
                    job_num:"",    //工号
                    work_date:"",  //入职时间
                    birth_date:"", //出生日期
                    phone_num:"",  //手机号码
                    position_id:"",//岗位
                    rank:"",       //职级
                    bu_id:"",      //所属BU
                    role_ids:[],   //角色ids
                },
                check_all:false,

                role_list:[],   //角色列表
                post_list:[],  //岗位列表
                bu_list:[],   //bu列表
                bu_name:"",   //BU名称
            }
        },
        computed:{
            ...mapState(["picker_special"]),
            all_ids(){  //角色列表id最大合集
                return this.role_list.map(item => item.id);
            },
            role_str(){  //id 拼成string
                return this.sub.role_ids.sort().join(',');
            },
            text(){  //按钮描述
                return this.id?"保存":"添加";
            },
        },

        watch:{
            index(val){
                if(val == 0){
                    this.getData();
                }
            },
        },

        created(){
            this.fresh();
        },


        mounted(){
            this.now_form = this.$form.forms["back-add-person"];
        },

        // beforeRouteLeave(to,from,next){  //离开页面之前
		// 	let res = this.$form.leave({name:'back-add-person',path:to.path});
		// 	next(res);
        // },
        
        methods:{
            fresh(){
                this.$http.get(`api/admin/role/list`).then(res=>{  // 角色列表
                    if(res.status == 200){
                        this.role_list = res.res_data;
                    }
                });

                this.$http.get(`api/user/position/all`).then(res=>{  //岗位列表
                    if(res.status == 200){
                        this.post_list = res.res_data;
                    }
                });

                this.$http.get(`api/admin/bu/list/excluderesigned`).then(res=>{  //bu列表
                    if(res.status == 200){
                        this.bu_list = res.res_data;
                    }
                });
                
                this.getData();
            },
            getData(){
                if(this.id){
                    let url = `api/admin/user/info`;
                    this.$http.get(url,{
                        params:{userId:this.id}
                    }).then(res=>{
                        if(res.status == 200){
                            let data = res.res_data;
                            this.$emit("getdata",{...data});
                            let sub = this.sub;
                            sub.name = data.realName;
                            sub.account = data.mail;
                            sub.job_num = data.userName;
                            sub.work_date = new Date(data.workDate);
                            sub.birth_date = new Date(data.birthDate);
                            sub.phone_num = data.mobile;
                            sub.position_id = data.positionId;
                            sub.rank = data.staffingGrade;
                            // sub.bu_id = data.bu.id;
                            this.bu_name = data.bu.buName;
                            sub.role_ids = data.roles.map(item=>item.id);

                            this.roleCheck();
                            this.$form.init("back-add-person");
                        }
                    })

                }else{
                    this.sub = {
                        name:"",       //姓名
                        account:"",    //账号         
                        job_num:"",    //工号
                        work_date:"",  //入职时间
                        birth_date:"", //出生日期
                        phone_num:"",  //手机号码
                        position_id:"",//岗位
                        rank:"",       //职级
                        bu_id:"",      //所属BU
                        role_ids:[],   //角色ids
                    };
                    this.roleCheck();
                    this.$form.init("back-add-person");
                }
            },

            // ***多选部分
            chooseAll(event){  //全选
                this.sub.role_ids = event.target.checked?[...this.all_ids]:[];
            },
            roleCheck(){  //单选
                this.check_all = this.sub.role_ids.length === this.all_ids.length && this.all_ids.length != 0;
            },

            save(){  //保存
                let res = this.$form.check("back-add-person");
                if(!res){
                    return;
                }
                if(!this.now_form.changeFlag){
                    this.successTip(`${this.text}成功`);
                    return;
                }
                this.$func.loading(true);
                
                if(this.id){
                    let url = `api/admin/user/update`;
                    this.$http.post(url,{
                        user_id:this.id,
                        user_name:this.sub.name,
                        user_account:this.sub.account,
                        work_num:this.sub.job_num,
                        user_mobile:this.sub.phone_num,
                        work_date:this.sub.work_date,
                        birthday:this.sub.birth_date,
                        position_id:this.sub.position_id,
                        grade:this.sub.rank,
                        bu_id:this.sub.bu_id,
                        roles:this.role_str,
                    }).then(res=>{
                        if(res.status == 200){
                            this.getData();
                            this.successTip(`${this.text}成功`);
                        }
                        this.$func.loading(false);
                    }).catch(err=>{
                        this.errorTip("出错了");
                        this.$func.loading(false);
                    });
                }else{
                    
                    let url =`api/admin/user/add`;
                    this.$http.post(url,{
                        user_name:this.sub.name,
                        user_account:this.sub.account,
                        work_num:this.sub.job_num,
                        user_mobile:this.sub.phone_num,
                        work_date:this.sub.work_date,
                        birthday:this.sub.birth_date,
                        position_id:this.sub.position_id,
                        grade:this.sub.rank,
                        bu_id:this.sub.bu_id,
                        roles:this.role_str,
                    }).then(res=>{
                        if(res.status == 200){
                            this.$form.breakFlag = true;
                            this.successTip(`${this.text}成功`);
    
                            this.$router.push({
                                name:"back-person-assign",
                            });
                        }
                        this.$func.loading(false);
                    }).catch(err=>{
                        this.errorTip("出错了");
                        this.$func.loading(false);
                    });
                }

            },
            cancel(){ //取消
                this.getData();
            },
        },
    }
</script>

<style lang="less">
    @import "~src/assets/less/backless/var.less";
    .z-add-person{
        .double-wrap{
            margin-top: 25px;
            overflow: hidden;
            .left,.right{
                float:left;
            }
            .left{
                width:390px;
            }
            .right{
                max-width:calc(~"100% - 390px");
            }
    
            &+.title{
                line-height: 30px;
                font-size:12px;
                color:#8d8d8d;
                border-bottom: 1px solid #ddd;
            }
        }
    
        @left_w:64px;
        .back-item{
            &:after{
                content:"";
                display: block;
                clear: both;
            }
            >div{
                float:left;
            }
            .back-title{
                width:@left_w;
                box-sizing: border-box;
            }
            .back-wrap{
                max-width:calc(~"100% - @{left_w}");
            }
    
            .role-item{
                margin-left:0;
                margin-right: 15px;
                margin-bottom: 15px;
                line-height: @line;
                height:@line;
                .el-checkbox__input{
                    height:100%;
                }
                .el-checkbox__label{
                    font-size:12px;
                }

            }
        }

        .check-head{
            line-height: @line;
            span{
                vertical-align: middle;
            }
        }

        .btns{
            margin-top: 30px;
            padding-left: @left_w;
            font-size:0;
            >.back-btn{
                font-size:14px;
            }
            .back-btn+.back-btn{
                margin-left: 15px;
            }
        }
    }
</style>





// WEBPACK FOOTER //
// person-info.vue?68be80c5